import React, { useState, useEffect, useRef } from 'react';

export const AnimatedCounter = ({ target, duration = 1500, suffix = '' }) => {
    const [count, setCount] = useState(0);
    const [hasAnimated, setHasAnimated] = useState(false);
    const elementRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !hasAnimated) {
                    setHasAnimated(true);
                }
            },
            { threshold: 0.1 }
        );

        if (elementRef.current) {
            observer.observe(elementRef.current);
        }

        return () => observer.disconnect();
    }, [hasAnimated]);

    useEffect(() => {
        if (!hasAnimated) return;

        let start = 0;
        const end = parseInt(target);
        if (start === end) return;

        const totalMiliseconds = duration;
        const incrementTime = totalMiliseconds / end;

        const timer = setInterval(() => {
            start += 1;
            setCount(start);
            if (start === end) clearInterval(timer);
        }, incrementTime);

        return () => clearInterval(timer);
    }, [hasAnimated, target, duration]);

    return <span ref={elementRef}>{count}{suffix}</span>;
};

export const AnimatedProgressBar = ({ width, className, fillClassName }) => {
    const [isVisible, setIsVisible] = useState(false);
    const elementRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.1 }
        );

        if (elementRef.current) {
            observer.observe(elementRef.current);
        }

        return () => observer.disconnect();
    }, []);

    return (
        <div ref={elementRef} className={className}>
            <div
                className={fillClassName}
                style={{
                    width: isVisible ? width : '0%',
                    transition: 'width 1.5s cubic-bezier(0.4, 0, 0.2, 1)'
                }}
            ></div>
        </div>
    );
};
